import {
  type Faro,
  getWebInstrumentations,
  initializeFaro as initFaro,
} from "@grafana/faro-web-sdk";

import { appVersion, runtimeEnv } from "@/core/lib/runtime-env";

import { buildTracingInstrumentation } from "./tracing";

let faro: Faro | null = null;

export function getFaro(): Faro | null {
  return faro;
}

export function initializeFaro(): Faro | null {
  if (faro) return faro;

  if (!import.meta.env.PROD) return null;

  const environment = runtimeEnv("VITE_DEPLOYMENT_ENVIRONMENT");
  if (!environment) return null;

  try {
    faro = initFaro({
      url: `${window.location.origin}/faro`,
      app: {
        name: "cynthai-frontend",
        version: appVersion(),
        environment,
      },
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: false }),
        buildTracingInstrumentation(),
      ],
      ignoreUrls: [
        /\/tracker\/message\/stream/,
        /\/audit\/document-analysis\/.*\/search/,
        /\/data\/export/,
        /\/file\//,
      ],
    });

    return faro;
  } catch (error) {
    console.error("Failed to initialize Faro:", error);
    return null;
  }
}
